import React from 'react';
import { useSelector } from 'react-redux';
import capitalize from 'lodash/capitalize';
import { currentAccountConsumerSelector } from 'store/account/selectors';
import { MuiBox } from 'theme/material-ui';
import { SliderBoxContainer } from 'components/DashboardCarousel/styled';
import {
  DashboardBannerCard,
  DashboardCards
} from 'components/DashboardCarousel/DashboardBannerCard';

interface Props {
  dataTestId?: string;
}

const DashboardCarouselNoData = ({ dataTestId }: Props) => {
  const currentConsumer = useSelector(currentAccountConsumerSelector);

  return (
    <MuiBox
      data-testid="dashboard-welcome-card"
      display="flex"
      justifyContent="center"
      width="100%"
    >
      <SliderBoxContainer totalCards={1}>
        <DashboardBannerCard
          title={`Welcome, ${capitalize(currentConsumer?.firstName || 'Guest')}, to My Health+.`}
          imageName={DashboardCards.welcome.imageName}
          background={DashboardCards.welcome.background}
          totalCards={1}
          dataTestId={dataTestId}
        />
      </SliderBoxContainer>
    </MuiBox>
  );
};

export default DashboardCarouselNoData;
